import {post} from '../utils'

export default host => data => {
  return post(`${host}/musicDealers`, JSON.stringify(data))
    .then(response => response.json())
}